if (!window.dAgency) window.dAgency = {};
window.dAgency.initBenefits = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const slidesContainer = sectionContainer.querySelector('.benefits__container-slider');
  const slides = slidesContainer.querySelectorAll('.benefits__container-slider .swiper-slide');
  const slidesCount = slides.length;

  if (slidesCount > 1) {
    const swiper = new Swiper(slidesContainer, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        enabled: false
      },
      pagination: {
        enabled: true,
        el: sectionContainer.querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 32,
          pagination: {
            enabled: false
          },
          navigation: {
            enabled: true,
            prevEl: sectionContainer.querySelector('.swiper-arrow.swiper-arrow-left'),
            nextEl: sectionContainer.querySelector('.swiper-arrow.swiper-arrow-right')
          },
        },
      },
    });
  }
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.benefits__container '), (el) => {
    window.dAgency.initBenefits(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.benefits__container '), (el) => {
      window.dAgency.initBenefits(el);
    });
  });
}
